import { render, staticRenderFns } from "./CustTableSEI.vue?vue&type=template&id=2ed18557"
import script from "./CustTableSEI.vue?vue&type=script&lang=js"
export * from "./CustTableSEI.vue?vue&type=script&lang=js"
import style0 from "./CustTableSEI.vue?vue&type=style&index=0&id=2ed18557&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports